import React from 'react';
import InputWrapper from './InputWrapper';

const TextInput = ({ maxLength = 999, field, fieldId, value, onChange, label, isRequired, error, placeholder }) => {
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <input
        type="text"
        className="profile-input form-input"
        value={value}
        onChange={e => onChange(fieldId, e.target.value)}
        maxLength={field.maxLength}
        placeholder={placeholder}
        disabled={field.readOnly || false}
      />
    </InputWrapper>
  );
};

export default TextInput;

